import { HGetKeyEnums } from "@rf-helper/generat-enums-from-keys";
import { SchemaItemGeneric } from "@rf/schemas/item-generic.shema";
import { array, InferType, number, object, string } from "yup";

export const PropertyDraftListFilterSchema = object({
  search: string().default(""),
  page: number().default(1),
  typeDraft: array().of(SchemaItemGeneric).default([])
});

export type IPropertyDraftListFilterSchema = InferType<
  typeof PropertyDraftListFilterSchema
>;
export const CPropertyDraftListFilter: IPropertyDraftListFilterSchema =
  PropertyDraftListFilterSchema.getDefault();
export const CPropertyDraftListFilterKeys = HGetKeyEnums(
  CPropertyDraftListFilter
) as {
  [K in keyof typeof CPropertyDraftListFilter]: K;
};
